import {
  BOMBudget,
  BomOwnerTrialBalance,
  BOMReviewBudget,
  Finance,
  Invoice,
  OwnerAddEditBudget,
  OwnerAddEditBilledForPeriod,
  OwnerAddEditBillingConfig,
  OwnerAddEditBillingLog,
  OwnerAddEditCashApp,
  OwnerAddEditClearing,
  OwnerAddEditInvoice,
  OwnerAddEditJournalEntry,
  OwnerAddEditLineItem,
  OwnerAddEditPayment,
  OwnerAddEditPendingPosting,
  OwnerAR360Report,
  OwnerAudit,
  OwnerAuditTrail,
  OwnerAuditTrailView,
  OwnerBalanceReports,
  OwnerBilledForPeriodListing,
  OwnerBilling,
  OwnerBillingConfig,
  OwnerBillingLogs,
  OwnerCashAppList,
  OwnerClearing,
  OwnerClearingListing,
  OwnerCloseoutReport,
  OwnerCollection,
  OwnerCostAnalytics,
  OwnerCostTrialBalance,
  OwnerDisplayAccountingDocument,
  OwnerDistributionMetricsMaintenance,
  OwnerDistributionRuleConfiguration,
  OwnerDistributionRunTimeDetails,
  OwnerFiscalYearClosing,
  OwnerFiscalYearLifecycle,
  OwnerFixedWeight,
  OwnerGeneralLedger,
  OwnerGLConfigurationStudio,
  OwnerGLTrialBalance,
  OwnerInvoiceListing,
  OwnerJournalEntryList,
  OwnerLineItems,
  OwnerPayment,
  OwnerPayment360InvoiceListing,
  OwnerPayment360Report,
  OwnerPaymentListing,
  OwnerPendingPostingListing,
  OwnerReconciliationReport,
  OwnerReportByOwner,
  OwnerReportByVendor,
  OwnerReports,
  OwnerToleranceReport,
  OwnerTraceabilityReport,
  OwnerVendorTrialBalance,
  OwnerViewJobDetails,
  OwnerViewJobGlDetails,
  OwnerWeighingFactor,
  OwnerWeighingFactorDetailedView,
} from "@/pages";
import { routes } from "../utils";
import BomProtectedRoute from "./BomProtectRoute";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const FinanceRoutes = () => {
  return {
    path: routes.finance,
    element: <BomProtectedRoute />,
    children: [
      {
        path: "",
        element: <Finance />,
      },
      {
        path: routes.budgetApprovals,
        children: [
          {
            path: "",
            element: <BOMBudget />,
          },
          {
            path: routes.add,
            element: (
              <PermissionGuard
                moduleKey={actionsKeys.BUDGET}
                action={routes.add}
              >
                <OwnerAddEditBudget />
              </PermissionGuard>
            ),
          },
          {
            path: routes.budgetId + "/" + routes.action,
            element: (
              <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerAddEditBudget />
              </PermissionGuard>
            ),
          },
          {
            path: routes.budgetId + "/review",
            element: (
              <PermissionGuard moduleKey={actionsKeys.BUDGET} action="view">
                <BOMReviewBudget />
              </PermissionGuard>
            ),
          },
          {
            path: routes.budgetId + "/" + routes.lineItems,
            element: (
              <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerLineItems />
              </PermissionGuard>
            ),
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.add,
            element: (
              <PermissionGuard
                moduleKey={actionsKeys.BUDGET}
                action={routes.add}
              >
                <OwnerAddEditLineItem />
              </PermissionGuard>
            ),
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.lineItemId +
              "/" +
              routes.action,
            element: (
              <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                <OwnerAddEditLineItem />
              </PermissionGuard>
            ),
          },
        ],
      },
      {
        path: routes.invoice,
        children: [
          {
            path: "",
            element: <Invoice />,
          },
          {
            path: routes.reports,
            element: <PermissionGuard moduleKey={actionsKeys.INVOICE_REPORT}>
                <OwnerReports />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.INVOICE} action={routes.add}>
                <OwnerAddEditInvoice />
              </PermissionGuard>
          },
          {
            // Listing UI based on status
            path: routes.invoiceAction,
            element: <PermissionGuard moduleKey={actionsKeys.INVOICE}>
              <OwnerInvoiceListing />
            </PermissionGuard>
          },
          {
            path:
              routes.invoiceAction +
              "/" +
              routes.invoiceId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.INVOICE}>
                <OwnerAddEditInvoice />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.payment,
        children: [
          {
            path: "",
            element: <OwnerPayment />,
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.PAYMENT} action={routes.add}>
                <OwnerAddEditPayment />
              </PermissionGuard>
          },
          {
            path: routes.paymentAction,
            element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                <OwnerPaymentListing />
              </PermissionGuard>
          },
          {
            path:
              routes.paymentAction +
              "/" +
              routes.paymentId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                <OwnerAddEditPayment />
              </PermissionGuard>
          },
          {
            path:
              routes.paymentAction +
              "/" +
              routes.paymentId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                <OwnerAddEditPayment />
              </PermissionGuard>
          },
          {
            path: routes.reports,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.PAYMENT_REPORT}>
                    <OwnerPayment360Report />
                  </PermissionGuard>
              },
              {
                path: routes.glId + "/" + routes.month,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.PAYMENT_REPORT}>
                        <OwnerPayment360InvoiceListing />
                      </PermissionGuard>
                  },
                  {
                    path: routes.invoiceId + "/" + routes.action,
                    element: <PermissionGuard moduleKey={actionsKeys.INVOICE}>
                        <OwnerAddEditInvoice />
                      </PermissionGuard>
                  },
                ],
              },
              {
                path:
                  routes.glId +
                  "/" +
                  routes.month +
                  "/" +
                  routes.listing +
                  "/" +
                  routes.paymentAction,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                        <OwnerPaymentListing />
                      </PermissionGuard>
                  },
                  {
                    path: routes.paymentId + "/" + routes.action,
                    element: <PermissionGuard moduleKey={actionsKeys.PAYMENT}>
                      <OwnerAddEditPayment />
                    </PermissionGuard>
                  },
                ],
              },
              {
                path: routes.vendorTrialBalance,
                element: <PermissionGuard moduleKey={actionsKeys.VENDOR_TRIAL_BALANCE}>
                    <OwnerVendorTrialBalance />
                  </PermissionGuard>
              },
            ],
          },
          {
            path: routes.tolerance,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.TOLERANCE_REPORT}>
                    <OwnerToleranceReport />
                  </PermissionGuard>
              },
              {
                path:
                  routes.budgetMgmt +
                  "/" +
                  routes.budgetId +
                  "/" +
                  routes.action,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.BUDGET}>
                        <BOMReviewBudget />
                      </PermissionGuard>
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: routes.billing,
        children: [
          {
            path: "",
            element: <OwnerBilling />,
          },
          {
            path: routes.billingConfig,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG}>
                <OwnerBillingConfig />
              </PermissionGuard>
          },
          {
            path: routes.billingConfig + "/" + routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG} action={routes.add}>
                <OwnerAddEditBillingConfig />
              </PermissionGuard>
          },
          {
            path:
              routes.billingConfig +
              "/" +
              routes.billingId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_CONFIG}>
                <OwnerAddEditBillingConfig />
              </PermissionGuard>
          },
          {
            path: routes.pendingPosting,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
                <OwnerPendingPostingListing />
              </PermissionGuard>
          },
          {
            path:
              routes.pendingPosting +
              "/" +
              routes.billingId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
                <OwnerAddEditPendingPosting />
              </PermissionGuard>
          },
          {
            path: routes.billedForPeriod,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
                <OwnerBilledForPeriodListing />
              </PermissionGuard>
          },
          {
            path:
              routes.billedForPeriod +
              "/" +
              routes.billingId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_DOCUMENT}>
                <OwnerAddEditBilledForPeriod />
              </PermissionGuard>
          },
          {
            path: routes.billingLog,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_LOGS}>
                <OwnerBillingLogs />
              </PermissionGuard>
          },
          {
            path:
              routes.billingLog + "/" + routes.billingId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.BILLING_LOGS}>
                <OwnerAddEditBillingLog />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.reports,
        element: <PermissionGuard moduleKey={actionsKeys.INVOICE_REPORT}>
            <OwnerReports />
          </PermissionGuard>
      },
      {
        path: routes.collection,
        children: [
          { path: "", element: <OwnerCollection /> },
          {
            path: routes.journalEntry,
            element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
                <OwnerJournalEntryList />
              </PermissionGuard>
          },
          {
            path: routes.journalEntry + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
                <OwnerAddEditJournalEntry />
              </PermissionGuard>
          },
          {
            path:
              routes.journalEntry +
              "/" +
              routes.billingId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys.UNIFIED_JE}>
                <OwnerAddEditJournalEntry />
              </PermissionGuard>
          },
          {
            path: routes.cashApp,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.CASH_APP}>
                    <OwnerCashAppList />
                  </PermissionGuard>
              },
              {
                path: routes.add,
                element: <PermissionGuard moduleKey={actionsKeys.CASH_APP} action={routes.add}>
                    <OwnerAddEditCashApp />
                  </PermissionGuard>
              },
              {
                path: routes.id + "/" + routes.status + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.CASH_APP}>
                    <OwnerAddEditCashApp />
                  </PermissionGuard>
              },
            ],
          },
          {
            path: routes.ar360,
            element: <PermissionGuard moduleKey={actionsKeys.COLLECTION_REPORT}>
                <OwnerAR360Report />
              </PermissionGuard>
          },
          {
            path: routes.ownerTrialBalance,
            element: <PermissionGuard moduleKey={actionsKeys.OWNER_TRIAL_BALANCE}>
                <BomOwnerTrialBalance />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.clearing,
        children: [
          {
            path: "",
            element: <OwnerClearing />,
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING} action={routes.add}>
                <OwnerAddEditClearing />
              </PermissionGuard>
          },
          {
            path: routes.listing,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING}>
                    <OwnerClearingListing />
                  </PermissionGuard>
              },
              {
                path: routes.clearingId + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.MANUAL_CLEARING}>
                    <OwnerAddEditClearing />
                  </PermissionGuard>
              },
            ]
          },
        ],
      },
      {
        path: routes.generalLedger,
        children: [
          {
            path: "",
            element: <OwnerGeneralLedger />
          },
          {
            path: routes.fiscalYearClosing,
            element: <PermissionGuard moduleKey={actionsKeys.FISCAL_YEAR}>
                <OwnerFiscalYearClosing />
              </PermissionGuard>
          },
          {
            path: routes.fiscalYearLifeCycle,
            element: <PermissionGuard moduleKey={actionsKeys.FISCAL_YEAR_LIFE_CYCLE}>
                <OwnerFiscalYearLifecycle />
              </PermissionGuard>
          },
          {
            path: routes.trialBalance,
            element: <PermissionGuard moduleKey={actionsKeys.GL_TRIAL_BALANCE}>
                <OwnerGLTrialBalance />
              </PermissionGuard>
          },
          {
            path: routes.displayAccountingDocument,
            element: <PermissionGuard moduleKey={actionsKeys.DISPLAY_ACCOUNTING_DOCUMENT}>
                <OwnerDisplayAccountingDocument />
              </PermissionGuard>
          },
          {
            path: routes.glConfigurationStudio,
            element: <PermissionGuard moduleKey={actionsKeys.GL_CONFIG}>
                <OwnerGLConfigurationStudio />
              </PermissionGuard>
          },
          // {
          //   path: routes.createJEManual,
          //   element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE} action={routes.add}>
          //       <OwnerCreateJEManual />
          //     </PermissionGuard>
          // },
          // {
          //   path: routes.jeManual + "/" + routes.status,
          //   children: [
          //     {
          //       path: "",
          //       element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE}>
          //           <OwnerParkedPostedJEListing />
          //         </PermissionGuard>
          //     },
          //     {
          //       path: routes.id + "/" + routes.action,
          //       element: <PermissionGuard moduleKey={actionsKeys.MANUAL_JE}>
          //           <OwnerJEDetails />
          //         </PermissionGuard>
          //     },
          //   ],
          // },
        ]
      },
      {
        path: routes.audit,
        children: [
          {
            path: "",
            element: <OwnerAudit />
          },
          {
            path: routes.auditTrail,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.AUDIT_TRAIL}>
                    <OwnerAuditTrail />
                  </PermissionGuard>
              },
              {
                path: routes.id + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.AUDIT_TRAIL}>
                    <OwnerAuditTrailView />,
                  </PermissionGuard>
              },
            ]
          },
        ]
      },
      {
        path: routes.costAnalytics,
        children: [
          {
            path: "",
            element: <OwnerCostAnalytics />
          },
          {
            path: routes.distributionMetricsMaintenance,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerDistributionMetricsMaintenance />,
                  </PermissionGuard>
              },
              {
                path: routes.weighingFactor + "/" + routes.id + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerWeighingFactorDetailedView />
                  </PermissionGuard>
              }
            ]
          },
          {
            path: routes.distributionRuntimeDetails,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerDistributionRunTimeDetails />
                  </PermissionGuard>
              },
              {
                path: routes.id,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerViewJobDetails />
                  </PermissionGuard>
              },
              {
                path: routes.id + "/" + routes.glId,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                  <OwnerViewJobGlDetails />
                </PermissionGuard>
              },
            ],
          },
          {
            path: routes.distributionRuleConfiguration,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerDistributionRuleConfiguration />
                  </PermissionGuard>
              },
              {
                path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
                element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                    <OwnerFixedWeight />
                  </PermissionGuard>
              },
              {
                path: routes.weighingFactor + "/" + routes.type,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                        <OwnerWeighingFactor />
                      </PermissionGuard>
                  },
                  {
                    path: routes.id + "/" + routes.details,
                    element: <PermissionGuard moduleKey={actionsKeys.DISTRIBUTION_CONFIG}>
                        <OwnerWeighingFactorDetailedView />
                      </PermissionGuard>
                  }
                ]
              }
            ]
          },
          {
            path: routes.traceability,
            children: [
              {
                path: "",
                element: <PermissionGuard moduleKey={actionsKeys.TRACEABILITY_BALANCE}>
                    <OwnerTraceabilityReport />
                  </PermissionGuard>
              },
              {
                path: `${routes.distributionRuleConfiguration}/${routes.glId}`,
                children: [
                  {
                    path: "",
                    element: <PermissionGuard moduleKey={actionsKeys.TRACEABILITY_BALANCE}>
                        <OwnerDistributionRuleConfiguration />
                      </PermissionGuard>
                  },
                  {
                    path: routes.fixedWeight + "/" + routes.level + "/" + routes.type + "/" + routes.action,
                    element: <PermissionGuard moduleKey={actionsKeys.TRACEABILITY_BALANCE}>
                        <OwnerFixedWeight />
                      </PermissionGuard>
                  },
                  {
                    path: routes.weighingFactor + "/" + routes.type,
                    children: [
                      {
                        path: "",
                        element: <PermissionGuard moduleKey={actionsKeys.TRACEABILITY_BALANCE}>
                            <OwnerWeighingFactor />
                          </PermissionGuard>
                      },
                      {
                        path: routes.id + "/" + routes.details,
                        element: <PermissionGuard moduleKey={actionsKeys.TRACEABILITY_BALANCE}>
                            <OwnerWeighingFactorDetailedView />
                          </PermissionGuard>
                      }
                    ]
                  }
                ]
              },
            ]
          },
          {
            path: routes.reconciliation,
            element: <PermissionGuard moduleKey={actionsKeys.RECONCILIATION_REPORT}>
                <OwnerReconciliationReport />
              </PermissionGuard>
          },
          {
            path: routes.closeout,
            element: <PermissionGuard moduleKey={actionsKeys.CLOSEOUT_BALANCE}>
                <OwnerCloseoutReport />
              </PermissionGuard>
          },
          {
            path: routes.vendorTrialBalance,
            element: <PermissionGuard moduleKey={actionsKeys.VENDOR_TRIAL_BALANCE}>
                <OwnerVendorTrialBalance />
              </PermissionGuard>
          },
          {
            path: routes.ownerTrialBalance,
            element: <PermissionGuard moduleKey={actionsKeys.OWNER_TRIAL_BALANCE}>
                <BomOwnerTrialBalance />
              </PermissionGuard>
          },
          {
            path: routes.costTrialBalance,
            element: <PermissionGuard moduleKey={actionsKeys.COST_ANALYTICS_TRIAL_BALANCE}>
                <OwnerCostTrialBalance />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.balanceReport,
        children: [
          {
            path: "",
            element: <OwnerBalanceReports />
          },
          {
            path: routes.reportByOwner,
            element: <PermissionGuard moduleKey={actionsKeys.OWNER_BALANCE_REPORT}>
                <OwnerReportByOwner />
              </PermissionGuard>
          },
          {
            path: routes.reportByVendor,
            element: <PermissionGuard moduleKey={actionsKeys.VENDOR_BALANCE_REPORT}>
                <OwnerReportByVendor />
              </PermissionGuard>
          },
        ]
      }
    ],
  };
};
